/*=========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
==========================================================================================*/

// import axios from '@/axios.js'
import store from "@/store/store";

export default {
  assignTraineeCoach({ commit }, trainee_coach) {
    return new Promise((resolve, reject) => {
      /*axios
        .post("/api/data-list/products/", { item: item })
        .then(response => {
          commit("ADD_ITEM", Object.assign(item, { id: response.data.id }));
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });*/

      store
        .dispatch("trainee-coach/create", trainee_coach)
        .then(res => {
          // commit("ADD_ITEM", res);
          resolve(res);
          // console.log("new state add item", store.state.companyManagement.users);
        })
        .catch(err => {
          console.log("trainee-coach create failed", err);
          reject(err);
        });
    });
  },
  fetchAssignTraineeCoaches({ commit },companyId) {
    return new Promise((resolve, reject) => {
      /*axios.get('/api/user-management/users')
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })*/

      /*const coach = new models.api.Coach({
        email: this.user_email,
        status: "mail_sent",
        email_verified: 0,
        password: null,
        username: null
      })*/
      let query={};
     if(companyId){
       query={query:{companyId:companyId}}
     }
     else{
       query={}
     }
      store
        .dispatch("trainee-coach/find",query)
        .then(res => {
          let c = 0;
          for (const tc in res.data) {
            store
              .dispatch("users/find",{query:{id: res.data[tc].coachId,
                  companyId:companyId}})
              .then(resTC => {
                res.data[tc]["coachName"] = `${`${resTC.data[0].firstName  } ${  resTC.data[0].lastName}`  }(${  resTC.data[0].email  })`
                c++;
                if(c === (2 * res.data.length) + 1 && c !== 0) {
                  commit("SET_TRAINEE_COACH", res.data);
                  resolve(res);
                }
              })
              .catch(errTC => {
                console.log("could not find coach", errTC)
              });

            store
              .dispatch("users/find", {query:{id: res.data[tc].traineeId,
                 companyId:companyId}})
              .then(resTC => {
                res.data[tc]["traineeName"] = `${`${resTC.data[0].firstName  } ${  resTC.data[0].lastName}`  }(${  resTC.data[0].email  })`
                c++;

                if(c === (2 * res.data.length) + 1 && c !== 0) {
                  commit("SET_TRAINEE_COACH", res.data);
                  resolve(res);
                }
              })
              .catch(errTC => {
                console.log("could not find trainee", errTC)
              });

            c++;
          }
        })
        .catch(err => {
          console.log("trainee-coach could not be found", err);
          reject(err);
        });
    });
  },
  fetchAssignTraineeCoachQuery(context, params) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("trainee-coach/find", params)
        .then(res => {
          // commit('SET_USERS', res.data)
          resolve(res);
        })
        .catch(err => {
          console.log("trainee-coach could not be found", err);
          reject(err);
        });
    });
  },
  updateAssignTraineeCoach(context, assigncoach) {
    return new Promise((resolve, reject) => {
      /*axios.get(`/api/user-management/users/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })*/
      store
        .dispatch("trainee-coach/patch", [assigncoach.id, assigncoach])
        .then(res => {
          //commit('SET_TRAINEE_COACH', assigncoach.id)
          resolve(res);
        })
        .catch(err => {
          console.log("company could not be found", err);
          reject(err);
        });
    });
  },
  removeAssignTraineeCoach({ commit }, userId) {
    return new Promise((resolve, reject) => {
      /*axios.delete(`/api/user-management/users/${userId}`)
        .then((response) => {
          commit('REMOVE_RECORD', userId)
          resolve(response)
        })
        .catch((error) => { reject(error) })*/
      store
        .dispatch("trainee-coach/remove", userId)
        .then(res => {
          commit("REMOVE_RECORD", userId);
          resolve(res);
        })
        .catch(err => {
          console.log("The selected coach could not be deleted", err);
          reject(err);
        });
    });
  },
  fetchTrainees({commit}, query) {
    return new Promise((resolve, reject) => {
      store.dispatch("trainee-coach/find", query)
        .then(res => {
          commit("SET_ALL_TRAINEES", res.data)
          resolve(res)
        })
        .catch(err => {
          console.log("could not found trainees", err);
          reject(err)
        })
    });
  },
  setSidebarId({commit}, id) {
    return new Promise((resolve, reject) => {
      commit("SET_SIDEBAR_ID", id)
      resolve(id)
    })
  }
};
